import { SpeedIndexAbsoluteValues } from '../../_constants/speed_value_absolute_values';

function getAbsoluteValueForSpeedIndex(speedIndex) {

    return SpeedIndexAbsoluteValues[speedIndex] || '';
}

export { getAbsoluteValueForSpeedIndex };